import { useApi } from '@omnipresentgroup/api';
import type {
  GetEmployeeTimeOffsAPIResponse,
  TimeOffScope,
} from '@omnipresentgroup/types';
import { useQuery } from '@tanstack/react-query';

import { API_BASE, API_PATH } from '../constants';
import { transformTimeOffsFromAPI } from '../mappers';

export const getTimeOffsKey = (id: string) => [API_PATH, id];

export const useTimeOffsQuery = ({
  employeeId,
  companyId,
  enabled,
}: {
  employeeId?: string;
  companyId?: string;
  enabled?: boolean;
}) => {
  const { GET } = useApi();
  const path = `${API_BASE}/${API_PATH}`;

  // Only set scope if we have the corresponding ID
  let scope: TimeOffScope | undefined;
  let id: string | undefined;

  if (employeeId) {
    scope = 'employee';
    id = employeeId;
  } else if (companyId) {
    scope = 'company';
    id = companyId;
  }

  const isQueryEnabled = enabled !== false && Boolean(id && scope);

  const query = useQuery({
    queryKey: [API_PATH, id, scope, path],
    queryFn: () => {
      if (!id || !scope) {
        return Promise.reject(
          new Error('Invalid parameters to fetch time off'),
        );
      }
      return GET<GetEmployeeTimeOffsAPIResponse<typeof scope>>(
        `${path}/by-${scope}-id/${id}/requests`,
      );
    },
    enabled: isQueryEnabled,
    select: (data) => transformTimeOffsFromAPI(data),
  });

  return query;
};
